export default __webpack_public_path__ + "static/media/Marketing 360o Solution.7a7a58bf.png";